import {Content, isFilled} from '@prismicio/client'
import {PrismicRichText, SliceComponentProps} from '@prismicio/react'
import {Container} from 'src/common/Container'
import {PackageSection} from './components/PackageSection'
import {VariationLink} from './components/VariationLink'
import {Context} from 'src/common/types'

/**
 * Props for `PricingSection`.
 */
export type PricingSectionProps = SliceComponentProps<Content.PricingSectionSlice> & {context: Context}

/**
 * Component for "PricingSection" Slices.
 */
const PricingSection = ({
  slice,
  index: componentIndex,
  context: {pageUid, buttonsData},
}: PricingSectionProps): JSX.Element => {
  return (
    <Container
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      backgroundColor={slice.variation === 'reskin' ? 'Grey/100' : 'Beige/100'}
      id="pricing-section"
    >
      <div className="grid-base max-w-[1200px] gap-y-14 px-5 md:px-10 lg:gap-y-[96px] lg:px-5 xl:px-0">
        <div className="col-span-full flex flex-col gap-4 md:col-span-10 md:col-start-2 lg:col-span-6 lg:col-start-4">
          {isFilled.keyText(slice.primary.title) && (
            <h3 className="text-h3 text-center text-moss-black">{slice.primary.title}</h3>
          )}
          {isFilled.richText(slice.primary.subtext) && (
            <PrismicRichText
              field={slice.primary.subtext}
              components={{
                paragraph: ({children}) => (
                  <p className="text-tg-body-m md:text-tg-body-l text-center text-grey-550">{children}</p>
                ),
              }}
            />
          )}
          <VariationLink
            variation={slice.variation}
            componentIndex={componentIndex}
            pageUid={pageUid}
            buttonsData={buttonsData}
            {...(slice.variation === 'default'
              ? {
                  label: slice.primary.text_link_label,
                  url: slice.primary.text_link_url,
                }
              : {
                  primaryButton: slice.primary.primary_button,
                  secondaryButton: slice.primary.secondary_button,
                })}
          />
        </div>
        <div className="col-span-full grid grid-cols-subgrid gap-y-10">
          <PackageSection
            title={slice.primary.first_package_title}
            modules={slice.primary.first_package}
            variation={slice.variation}
            enableContainer
          />
          <PackageSection
            title={slice.primary.second_package_title}
            modules={slice.primary.second_package}
            variation={slice.variation}
          />
          <PackageSection
            title={slice.primary.third_package_title}
            modules={slice.primary.third_package}
            variation={slice.variation}
          />
        </div>
      </div>
    </Container>
  )
}

export default PricingSection
